import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["confirmFn"];
import { Modal } from "antd";
var useConfirm = function useConfirm() {
  return function (options) {
    Modal.confirm(options);
  };
};
var Confirm = function Confirm(_ref) {
  var confirmFn = _ref.confirmFn,
    renderOptions = _objectWithoutProperties(_ref, _excluded);
  confirmFn(renderOptions);
};
export { useConfirm, Confirm };